module.exports = __webpack_public_path__ + "img/post-cmt-white.04b76fd6.svg";